module.exports = __webpack_public_path__ + "static/media/Mr.Grill_tv_gif.8f8ce166.gif";